import React from 'react';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { AppThemeProvider, ToastProvider } from '@/shared/ui';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import Router from './router';

// Create a browserRouter instance
const router = createBrowserRouter([
  {
    path: '*',
    element: <Router />
  }
]);

const App: React.FC = () => {
  return (
    <AppThemeProvider>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <ToastProvider>
          <RouterProvider router={router} />
        </ToastProvider>
      </LocalizationProvider>
    </AppThemeProvider>
  );
};

export default App;
